'use client';

import React from 'react';
import Link from 'next/link';
import { trackAdobeClick } from '@/utils/adobe/click';

export interface RelatedTopicCardLinkProps {
  href: string;
  clickName: string;
  className?: string;
  metadataUid?: string;
}

// Client wrapper for a related-topics card link; fires the Adobe Click event on user click
export const RelatedTopicCardLink = ({
  href,
  clickName,
  className,
  metadataUid,
  children,
}: React.PropsWithChildren<RelatedTopicCardLinkProps>) => {
  // Track the click with explicit location/type; append the CMS metadata uid when present
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackAdobeClick(
      {
        clickName,
        clickLocation: `Related-Topics${metadataUid ? `_${metadataUid}` : ''}`,
        clickType: 'related-topic-card-link',
      },
      e
    );
  };

  return (
    <Link href={href} className={className} aria-label={clickName} onClick={handleClick}>
      {children}
    </Link>
  );
};
